// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    if ($('.main-nav-item').length) {
        watchMainNav();
    }

    if ($('#navigator').length) {
        watchNav();
    }

    if ($('.no-link.carousel-link').length) {
        $('.no-link.carousel-link').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
            });
        });
    }

    // $(this).on('click', function () {
    //     console.log('vw = ' + $(this))
    // });

    if ($('.blog-previews-container').length) {
        $('.blog-previews-container').each(function () {
            let $blogGlide = new Glide(".blog-previews-container", {
                type: "carousel",
                perView: 4,
                gap: 10,
                keyboard: true,
                breakpoints: {
                    1200: {
                        perView: 3
                    },
                    992: {
                        perView: 2
                    },
                    680: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }

    if ($('.testimonials-glide-list').length) {
        $('.testimonials-glide-list').each(function () {
            new Glide(".testimonials-glide-list", {
                type: "carousel",
                perView: 2,
                keyboard: true,
                breakpoints: {
                    992: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }

    // Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }

    if ($('.error-block.resend-verification-email').length) {
        resendVerificationEmail();
    }

    if ($('.page-elements-bar-container').length) {
        watchElementNavBar();
    }

    if (typeof imageMapResize !== 'undefined') {
        imageMapResize();
    }

    if ($('#map').length) {
        makeMap();
    }
});

var map;

function makeMap() {
    // console.log('makeMap() called');

    let $mapEle = $('.practices-map');
    // console.log('Map element found:', $mapEle.length);

    let $data = $mapEle.data('practice');
    let $locationType = $mapEle.data('location-type');
    let $region = $mapEle.data('region');

    // console.log('Data:', $data);
    // console.log('Location Type:', $locationType);

    $.ajax({
        url: '/Practice/getPractices',
        method: 'POST',
        data: {data: $data, locationType: $locationType, region: $region},
        dataType: 'json',
        success: function ($data) {
            // console.log('AJAX success, received data:', $data);

            let $result = JSON.parse(JSON.stringify($data));
            // console.log('Parsed result:', $result);
            // console.log('Number of results:', Object.keys($result).length);

            if (Object.keys($result).length === 1) {
                $.each($result, function (i, val) {
                    // console.log('Single location:', val);
                    // Convert strings to numbers
                    let lat = parseFloat(val['lat']);
                    let lng = parseFloat(val['long']);

                    // console.log('Converted coordinates:', lat, lng);

                    map = L.map('map').setView([lat, lng], 15);
                    let myFeatureGroup = L.featureGroup().addTo(map);

                    let marker = L.marker([lat, lng]).addTo(myFeatureGroup)
                        .bindPopup('<span class="sub-heading">' + val['title'] + '</span>');
                    marker.ch = $data;

                    myFeatureGroup.on('click', flyOver);
                });
            } else {
                // console.log('Multiple locations, creating map');
                // Initialize map without specific center - we'll fit bounds later
                map = L.map('map');
                let myFeatureGroup = L.featureGroup().addTo(map);

                $.each($result, function (i, val) {
                    // console.log('Adding marker for:', val);
                    // Convert strings to numbers
                    let lat = parseFloat(val['lat']);
                    let lng = parseFloat(val['long']);
                    let ext = val['external'];

                    if (!isNaN(lat) && !isNaN(lng)) {
                        if (ext) {
                            let marker = L.marker([lat, lng]).addTo(myFeatureGroup)
                                .bindPopup('<span class="sub-heading">' + val['title'] + '</span><br>' +
                                    '<a href="' + i + '" target="_blank">Click here to learn more.' + '</a>');
                            marker.ch = $data;
                        } else {
                            let marker = L.marker([lat, lng]).addTo(myFeatureGroup)
                                .bindPopup('<span class="sub-heading">' + val['title'] + '</span><br>' +
                                    '<a href="/' + i + '">Click here to learn more.' + '</a>');
                            marker.ch = $data;
                        }
                    }
                });

                myFeatureGroup.on('click', flyOver);

                // Fit the map to show all markers with some padding
                if (myFeatureGroup.getBounds().isValid()) {
                    map.fitBounds(myFeatureGroup.getBounds(), {
                        padding: [50, 50] // Add 50px padding around the markers
                    });
                }
            }

            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(map);

            let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
                $northEast = L.latLng(-30.939924331023455, 189.44824218750003);

            let $bounds = L.latLngBounds($southWest, $northEast);

            map.setMaxBounds($bounds);
            map.setMinZoom(5);

            watchMapIcons();
        },
        error: function(xhr, status, error) {
            console.error('AJAX error:', status, error);
            console.error('Response:', xhr.responseText);
        }
    });
}

function watchMapIcons() {
    let popupSpawn = $('.leaflet-pane.leaflet-popup-pane');
    let popupMarker = null;

    $(document).on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            setTimeout(function () {
                if (popupSpawn.children().length > 0) {
                    if (popupMarker === null || $(e.target).hasClass('.leaflet-marker-icon')) {
                        popupMarker = $(e.target);
                    }

                    let popup = $(popupSpawn).find('.leaflet-popup-content');
                    let link = $(popup).find('a');

                    link.focus();

                    if ($(e.target).hasClass('leaflet-popup-close-button')) {
                        popupMarker.focus();
                        popupMarker = null;
                    }
                }
            }, 100);
        }
    });
}

function flyOver(event) {
    map.flyTo([event.layer.getLatLng().lat, event.layer.getLatLng().lng], 15);
}

$(document).on('scroll', function () {
    $('.animate').not('.run').each(function () {
        if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run')
    })
}).trigger('scroll')


function watchElementNavBar() {
    let $elements = $('.element');
    let $eleBar = $('.elements-bar-container');
    let $navLinks = $eleBar.children('.page-element').children('a');
    let $elementObjects = {};

    $elements.each(function () {
        let $id = $(this).attr('id');

        $elementObjects[$id] = $(this).offset().top - $(window).scrollTop() - 100;
    });

    $navLinks.on('click', function (e) {
        $navLinks.each(function () {
            $(this).removeClass('active');
        })

        if (!$(this).hasClass('active')) {
            $(this).addClass('active');

            let $chosenDistance = $elementObjects[$(this).data('distance-key')]

            $('html, body').animate({
                scrollTop: $chosenDistance - 100 // Scroll down 300 pixels
            }, 0);
        }
    });

    $navLinks.each(function () {
        $(this).on('click', function (e) {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            }
        })
    });

    // // console.log($elementObjects);

    // $(window).on('scroll', function () {
    // let $distanceFromTop = $(window).scrollTop();
    // console.log($distanceFromTop + 15)
    // console.log($elementObjects['e51'])
    // console.log($distanceFromTop + 15 >= $elementObjects['e51'])

    // $navLinks.each(function () {
    //     let $id = $(this).attr('href').split('#')[1];
    //
    //     console.log($distanceFromTop)
    //
    //     if ($distanceFromTop + 15 >= $elementObjects[$id] && !$(this).hasClass('active')) {
    //         $(this).addClass('active');
    //     } else if ($distanceFromTop - 15 <= $elementObjects[$id] && $(this).hasClass('active')) {
    //         $(this).removeClass('active');
    //     }
    // });
    // });
}

function resendVerificationEmail() {
    let targetArea = $('.error-block.resend-verification-email .element-container .content-element-btn-container');
    let target = targetArea.children('a');

    if (target.text() === 'Resend verification email') {
        target.on('click', function () {
            $.ajax({
                url: '/SignUp/resendVerificationEmail',
                method: 'POST',
                dataType: 'json',
                success: function (data) {
                    let results = JSON.parse(JSON.stringify(data));

                    if (results === 'success') {
                        targetArea.parent().append('<p class="message good">You have successfully been registered. ' +
                            'Please check your email for the verification link. In case you don\'t see it, ' +
                            'please check your spam and junk folders. You won\'t be able to see the map without ' +
                            'verifying your email first.</p>');
                    } else {
                        targetArea.parent().append('<p class="message bad">Something went wrong. Please try logging' +
                            'in first. If you are already logged in or the error persists, please contact us ' +
                            'at <a href="mailto:help@logicstudio.nz">help@logicstudio.nz</a></p>');
                    }
                }
            });
        });
    }
}

function changeErrMsg() {
    let targetParent = $('.nocaptcha')

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

function watchNav() {
    let $targets = $('.main-nav-item').find('i.toggler');

    $targets.on('click', function () {
        let $this = $(this).closest('.nav-item');

        $targets.each(function () {
            let $parent = $(this).parent();

            if ($parent.hasClass('show-children') && !$parent.is($this)) {
                $parent.removeClass('show-children');

                let $subNav = $parent.find('.nav-secondary');
                $subNav.height(0);
            }
        });

        $this.toggleClass('show-children');

        let $subNav = $this.find('.nav-secondary');

        if ($this.hasClass('show-children')) {
            $subNav.height('auto');
            let ht = $subNav.height();
            $subNav.height(0);
            $subNav.height(ht);
        } else {
            $subNav.height(0);
        }
    });
}

function watchMainNav() {
    let $targets = $('.main-nav-item');

    $targets.on('mouseenter', function () {
        let $target2 = $(this).children('.nav-secondary');

        $target2.on('mouseenter', function () {
            let $parent = $(this).parent();

            if (!$parent.hasClass('active')) {
                $parent.addClass('active')
            }
        })

        $target2.on('mouseleave', function () {
            let $parent = $(this).parent();

            if ($parent.hasClass('active')) {
                $parent.removeClass('active')
            }
        })
    });
}

$(document).ready(function () {
    $('.blog-search-input').on('input', function () {
        const searchTerm = $(this).val().toLowerCase().trim();
        const searchWords = searchTerm.split(/\s+/); // Split input into individual words

        // Iterate over all blog-items-list elements on the page
        $('.carousel-items-list').each(function () {
            const $blogList = $(this);
            const $blogItems = $blogList.find('.carousel-item');

            let hasVisibleItems = false;

            $blogItems.each(function () {
                const itemText = $(this).text().toLowerCase();
                // Check if all search words are present in the item's text
                const matchesAllWords = searchWords.every(word => itemText.includes(word));

                if (matchesAllWords) {
                    $(this).show();
                    hasVisibleItems = true;
                } else {
                    $(this).hide();
                }
            });

            // Add or remove no-results class based on visibility
            if (!hasVisibleItems) {
                $blogList.addClass('no-results');
            } else {
                $blogList.removeClass('no-results');
            }
        });
    });
});
